import { CalendarCheck, Briefcase, FolderArchive, ShieldCheck, Lock, FileDown, HardDrive, FileText } from "lucide-react";

const features = [
  { icon: HardDrive, title: "Podaci ostaju kod vas", desc: "Sve se sprema isključivo lokalno u vaš preglednik, bez servera i bez računa" },
  { icon: FileDown, title: "PDF izvještaj za ravnatelja", desc: "Na kraju dana preuzmite uredan PDF i pošaljite ga ravnatelju e-poštom" },
  { icon: Lock, title: "Zaključavanje evidencije", desc: "Nakon pregleda evidencija se zaključava i štiti od naknadnih izmjena" },
];

export default function Pocetna({ settings, onSelect, recordCount, onLoadExample }) {
  return (
    <div className="animate-fade-in" data-testid="pocetna-view">
      <div className="mb-8">
        <p className="mb-2 inline-flex items-center gap-1.5 rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-semibold text-sky-700">
          <ShieldCheck className="h-3.5 w-3.5" /> Za sve škole u Hrvatskoj
        </p>
        <h1 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">
          {settings.nazivSkole || "Dnevna evidencija dežuranja"}
        </h1>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-600">
          {settings.nazivSkole
            ? "Dnevna evidencija dežuranja. Odaberite način rada, ispunite podatke tijekom dana i na kraju preuzmite PDF izvještaj za ravnatelja."
            : "Odaberite način rada, ispunite podatke tijekom dana i na kraju preuzmite PDF izvještaj za ravnatelja. Naziv svoje škole postavite u Postavkama."}
        </p>
        <button
          data-testid="ucitaj-primjer-btn"
          onClick={onLoadExample}
          className="mt-4 inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-xs font-semibold text-slate-600 shadow-sm transition-colors hover:border-sky-300 hover:bg-slate-50 active:scale-[0.98]"
        >
          <FileText className="h-4 w-4 text-sky-600" /> Učitaj ogledni primjer
        </button>
      </div>

      <div className="mb-8 grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <button
          data-testid="pocetna-nastavni-btn"
          onClick={() => onSelect("nastavni")}
          className="group rounded-2xl border border-slate-200/80 bg-white p-6 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-sky-300 hover:shadow-md active:scale-[0.99]"
        >
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-sky-600 text-white transition-transform group-hover:scale-105">
            <CalendarCheck className="h-6 w-6" />
          </div>
          <h3 className="font-heading text-base font-bold text-slate-900">1. Nova evidencija za nastavni dan</h3>
          <p className="mt-1 text-xs leading-relaxed text-slate-500">Osnovni podaci, autobusi, posjetitelji, zapažanja, sigurnosni događaji i zaključavanje</p>
        </button>
        <button
          data-testid="pocetna-nenastavni-btn"
          onClick={() => onSelect("nenastavni")}
          className="group rounded-2xl border border-slate-200/80 bg-white p-6 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-sky-300 hover:shadow-md active:scale-[0.99]"
        >
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-blue-600 text-white transition-transform group-hover:scale-105">
            <Briefcase className="h-6 w-6" />
          </div>
          <h3 className="font-heading text-base font-bold text-slate-900">2. Nova evidencija za nenastavni dan</h3>
          <p className="mt-1 text-xs leading-relaxed text-slate-500">Praznici, stručna usavršavanja i odmori, bez rasporeda nastave i autobusa</p>
        </button>
        <button
          data-testid="pocetna-arhiva-btn"
          onClick={() => onSelect("arhiva")}
          className="group rounded-2xl border border-slate-200/80 bg-white p-6 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-sky-300 hover:shadow-md active:scale-[0.99]"
        >
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-slate-900 text-white transition-transform group-hover:scale-105">
            <FolderArchive className="h-6 w-6" />
          </div>
          <h3 className="font-heading text-base font-bold text-slate-900">3. Učitaj i uredi prethodne evidencije</h3>
          <p className="mt-1 text-xs leading-relaxed text-slate-500">{recordCount > 0 ? `${recordCount} spremljenih evidencija u ovom pregledniku` : "Još nema spremljenih evidencija"}</p>
        </button>
      </div>

      <div className="grid gap-4 sm:grid-cols-3">
        {features.map((f) => {
          const Icon = f.icon;
          return (
            <div key={f.title} className="flex items-start gap-3 rounded-2xl border border-slate-200/60 bg-slate-50/60 p-4">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-sky-600 shadow-sm">
                <Icon className="h-4 w-4" />
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-800">{f.title}</p>
                <p className="mt-0.5 text-xs leading-relaxed text-slate-500">{f.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
